'use strict';

/**
 * @classname CategoryAccordion
 * @classdesc カテゴリーアコーディオン
 */
export default class CategoryAccordion {
	/**
	 * @constructor
	 * @param {jQuery} $e - .list--sp-category .list__item__link--accordion
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof CategoryAccordion
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		$('.list--sp-category.list--inner').show();
		this._$e.hide();
	};
};
